/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchAlertsResponseItem { 
    id: string;
    accountName?: string | null;
    miningProductId: number;
    miningProductName: string;
    miningProductCode: string;
    typeName: string;
    positiveFrequency: number;
    negativeFrequency: number;
    percentThreshold: number;
    isEmailSendingEnabled: boolean;
    isTelegramSendingEnabled: boolean;
    isActive: boolean;
}

